// src/pages/skills/views/Skills.view.tsx
import React from "react";
import i18n from "../../../i18n/i18n";
import Header from "../../../components/header/Header";
import { SkillsViewProps } from "../types";
import Button from "../../../components/global/Button";
import LazyLoadedSection from "../../../components/lazyloadedsection/LazyLoadedSection.view";

import {
  SkillsContainer,
  PageTitle,
  CategoryFilters,
  CategoryButton,
  SkillsGrid,
  SkillCard,
  SkillHeader,
  SkillIconWrapper,
  SkillInfo,
  SkillName,
  SkillCategory,
  SkillBarContainer,
  SkillBarInfo,
  SkillBar,
  SkillLevel,
  SkillDescription,
  SkillMeta,
  ButtonsWrapper,
} from "../Skills.styled";

export function SkillsView({
  isLoading,
  skills,
  categories,
  selectedCategory,
  setSelectedCategory,
}: SkillsViewProps) {
  const t = (key: string, defaultValue?: string) =>
    (i18n as any).t(key, defaultValue);
  const filteredSkills = selectedCategory
    ? skills.filter(skill => skill.category === selectedCategory)
    : skills;

  return (
    <>
      <Header />
      <main>
        <SkillsContainer>
          <PageTitle>{t("skills:title", "Skills")}</PageTitle>
          <LazyLoadedSection visible={!isLoading}>
            <CategoryFilters>
              {" "}
              <CategoryButton
                active={selectedCategory === null}
                onClick={() => setSelectedCategory(null)}
              >
                <i className="ph-squares-four"></i>
                {t("skills:all", "All")}
              </CategoryButton>{" "}
              {categories.map(category => (
                <CategoryButton
                  key={category.id}
                  active={selectedCategory === category.name}
                  onClick={() => setSelectedCategory(category.name)}
                >
                  <i className={category.icon}></i>
                  {t(`skills:categories.${category.name}`, category.name)}
                </CategoryButton>
              ))}
            </CategoryFilters>

            <SkillsGrid>
              {" "}
              {filteredSkills.map(skill => (
                <SkillCard key={skill.id}>
                  {" "}
                  <SkillHeader>
                    <SkillIconWrapper>
                      {"logo" in skill && (skill as any).logo ? (
                        <img
                          src={(skill as any).logo}
                          alt={`${skill.name} logo`}
                          width={28}
                          height={28}
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: 6,
                            padding: 2,
                          }}
                          onError={e => {
                            const target = e.currentTarget as HTMLImageElement;
                            target.style.display = "none";
                          }}
                        />
                      ) : (
                        <i
                          className={`ph-${skill.icon}`}
                          style={{ fontSize: "24px" }}
                        ></i>
                      )}
                    </SkillIconWrapper>
                    <SkillInfo>
                      <SkillName>{skill.name}</SkillName>
                      <SkillCategory>{skill.category}</SkillCategory>
                    </SkillInfo>
                  </SkillHeader>
                  <SkillBarContainer>
                    {" "}
                    <SkillBarInfo>
                      <span>{t("skills:proficiency", "Proficiency")}</span>
                      <span>{skill.level}%</span>
                    </SkillBarInfo>
                    <SkillBar>
                      <SkillLevel
                        width={skill.level}
                        style={{ width: `${skill.level}%` }}
                      />
                    </SkillBar>
                  </SkillBarContainer>
                  {skill.description && (
                    <SkillDescription>{skill.description}</SkillDescription>
                  )}
                  <SkillMeta>
                    {" "}
                    {skill.yearsOfExperience && (
                      <div>
                        <i
                          className="ph-clock"
                          style={{ fontSize: "18px" }}
                        ></i>
                        <span>
                          {skill.yearsOfExperience} {t("skills:years", "years")}
                        </span>
                      </div>
                    )}
                    {skill.projects && (
                      <div>
                        <i
                          className="ph-folders"
                          style={{ fontSize: "18px" }}
                        ></i>
                        <span>{skill.projects} projetos</span>
                      </div>
                    )}
                  </SkillMeta>
                </SkillCard>
              ))}
            </SkillsGrid>
          </LazyLoadedSection>
          {/* Featured Projects removido conforme solicitação */}
          
          <ButtonsWrapper
            style={{ justifyContent: "center", marginTop: "5rem" }}
          >
            {/* Botão para projetos removido, não há seção exibida */}
            <Button
              onClick={() => window.open("/contact", "_self")}
              variant="outlined"
            >
              {t("common:contactMe", "Contact Me")}
            </Button>
          </ButtonsWrapper>
        </SkillsContainer>
      </main>
    </>
  );
}

export default SkillsView;
